/**
 * WHERE the host is, decided by the DEPLOY and nothing else (moved out of apps/tasks' prod-config so apps/web decides it the same way;
 * TASKS-APP-FULL-UI-1 U2b). TWO MODES, never mixed (a loose override must not reopen «two Vittos»):
 *   · DEPLOY: `VITE_VITTO_ORIGIN` is set (the troquel's input, the same value its `frame-ancestors` is written from). EVERYTHING derives
 *     from it and from the manifest slug; every `VITE_TASKS_*` is IGNORED.
 *   · HARNESS: no `VITE_VITTO_ORIGIN` (vitto's two-stack harnesses pass only the old `VITE_TASKS_*` names): those are read.
 * No origin in either mode => null: the app is not connected to a host, production never guesses where it is.
 */
export type HostEnv = {
  VITE_VITTO_ORIGIN?: string;
  VITE_TASKS_VITTO_ORIGIN?: string;
  VITE_TASKS_VITTO_API?: string;
  VITE_TASKS_APP_NAME?: string;
  VITE_TASKS_PARENT_ORIGINS?: string;
};

export type HostConfig = {
  /** `deploy`: the troquel's origin is set; `harness`: only the old `VITE_TASKS_*`. */
  mode: 'deploy' | 'harness';
  vittoOrigin: string;
  apiOrigin: string;
  appName: string;
  parentOrigins: string[];
};

const nonEmpty = (value: string | undefined): string | undefined =>
  value === undefined || value === '' ? undefined : value;

export function hostConfigOf(env: HostEnv, slug: string): HostConfig | null {
  const deployed = nonEmpty(env.VITE_VITTO_ORIGIN);
  if (deployed !== undefined) {
    return {
      mode: 'deploy',
      vittoOrigin: deployed,
      apiOrigin: deployed,
      appName: slug,
      parentOrigins: [deployed],
    };
  }
  const vittoOrigin = nonEmpty(env.VITE_TASKS_VITTO_ORIGIN);
  if (vittoOrigin === undefined) return null;
  const parents = nonEmpty(env.VITE_TASKS_PARENT_ORIGINS);
  return {
    mode: 'harness',
    vittoOrigin,
    apiOrigin: nonEmpty(env.VITE_TASKS_VITTO_API) ?? vittoOrigin,
    appName: nonEmpty(env.VITE_TASKS_APP_NAME) ?? slug,
    parentOrigins: (parents ?? vittoOrigin).split(',').map((origin) => origin.trim()),
  };
}
